/**
 * Retrieves the user's UUID from Auth0 localStorage data.
 * Returns null if not logged in or data is not available.
 */
export const getUserUuidFromLocalStorage = (): string | null => {
    try {
        // Find the Auth0 SPA JS localStorage key
        const auth0Key = Object.keys(localStorage).find((key) => key.startsWith('@@auth0spajs@@'))

        if (!auth0Key) {
            return null
        }

        const auth0Data = localStorage.getItem(auth0Key)
        if (!auth0Data) {
            return null
        }

        const parsed = JSON.parse(auth0Data)

        // Get the user UUID from the 'sub' claim (e.g., "auth0|647f50d7e0fdc115c1c65147")
        const sub = parsed?.body?.decodedToken?.claims?.sub

        if (sub) {
            return sub
        }

        return null
    } catch {
        return null
    }
}
